module.exports = __webpack_public_path__ + "static/img/295_TO8_1696_og.9ca544f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/295_TO8_1696_og.jpg
// module id = cO/h
// module chunks = 0